module.exports = new __parcel__URL__("31-minutos.8a14f7e3.jpg").toString();